import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledCreditIntroDialogContent = styled('div')`
  display: flex;
  flex-direction: column;

  ${({ isMobile }) =>
    isMobile &&
    `
    justify-content: center;
    align-items: center;
  `}

  .app-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px;
    padding-top: 24px;
    ${({ isMobile }) =>
      isMobile &&
      `
      max-width: 311px;
    `}
  }

  .section-1 {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .section-1-title {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
  .new-item {
    align-self: center;
    padding: 2px 12px;
    border-radius: 16px;
    position: relative;
    background: #ffffff0a;
    background-image: ${COLOR.rainbow};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .new-item::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    padding: 1px;
    background: ${COLOR.rainbow};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
  .new-text {
    background-image: ${COLOR.rainbow};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .section-2-item-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f4f5f7;
    border: solid #1e164e29 0.5px;
    border-radius: 8px;
    padding-right: 16px;
    padding-left: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
    gap: 8px;
  }
  @media only screen and (max-width: 768px) {
    .app-info {
      flex-direction: column;
      padding: 0px;
      padding-top: 8px;
      margin-left: -8px;
      margin-right: -8px;
    }
    .info-item {
      width: 100%;
      padding: 0px;
    }
  }
`;
export const StyledCreditIntroImage = styled('div')`
  ${({ isMobile }) =>
    isMobile &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `}

  .image-item {
    margin: -24px -24px 0 -24px;
    overflow: hidden;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    ${({ isMobile }) =>
      isMobile &&
      `
      max-width: 343px;
    `}
  }
  .image-item img {
    width: 100%;
    display: block;
    max-height: 320px;
    object-fit: cover;
  }
`;

export const StyledCreditIntroDialogAction = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  ${({ isMobile }) =>
    isMobile &&
    `
    width: 100%;
    .button-1 {
      width: 100%;
    }
    .button-1 button {
      width: 100%;
    }
  `}
`;
